/**
 * GlobalCSS
 *
 * Изменения относительно оригинала:
 * - .app-shell сохраняет max-width: 480px для мобильных маршрутов
 *   (технический контур, admin), но диспетчерский контур
 *   (.app-shell.dispatch-desktop) занимает всю ширину.
 * - На ≥1024px app-shell для диспетчера переключается в full-width режим.
 * - .disp-panel — контейнер правой/центральной панели с собственным скроллом.
 * - .disp-list  — контейнер левой (list) колонки.
 */

const css = `
/* P0-6: Google Fonts @import удалён — шрифты больше не зависят от сети.
   Используем нативный системный стек (см. src/design-system/tokens.ts, F.body),
   который доступен мгновенно и работает офлайн на устройстве техника. */
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent}
html,body,#root{height:100%}
body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;background:#0A0C12;color:#EEF3FA;overflow:hidden;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;transition:background .2s ease,color .2s ease}
/* 1.36.0 — Темизация на уровне <html data-theme>. Значения синхронизированы
   с палитрами в design-system/tokens.ts (DARK / LIGHT). */
html[data-theme="dark"] body{background:#0A0C12;color:#EEF3FA}
html[data-theme="light"] body{background:#F4F6FB;color:#161C27}
a{color:inherit}
button,input,textarea,select{font:inherit}
textarea{resize:none}
::-webkit-scrollbar{width:0}
@keyframes su{from{transform:translateY(14px);opacity:0}to{transform:translateY(0);opacity:1}}
@keyframes fi{from{opacity:0}to{opacity:1}}
@keyframes pi{0%{transform:scale(.86);opacity:0}60%{transform:scale(1.03)}100%{transform:scale(1);opacity:1}}
@keyframes sp{from{transform:rotate(0)}to{transform:rotate(360deg)}}
@keyframes pr{0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(61,142,255,.45)}50%{opacity:.7;box-shadow:0 0 0 5px rgba(61,142,255,0)}}
@keyframes sb{from{transform:translateY(100%)}to{transform:translateY(0)}}
.interactive-card-link{display:block;text-decoration:none;touch-action:manipulation;cursor:pointer}
.interactive-card-link>div{transition:transform .12s ease,background .12s ease,border-color .12s ease,box-shadow .12s ease}
.interactive-card-link:focus-visible>div{outline:2px solid #8B5CF6;outline-offset:2px;border-color:rgba(139,92,246,.5)}
.interactive-card-link:active>div{transform:scale(.995);background:#0F1520;border-color:rgba(139,92,246,.45);box-shadow:0 8px 18px rgba(0,0,0,.18)}
@media (hover:hover){.interactive-card-link:hover>div{border-color:rgba(139,92,246,.35);box-shadow:0 8px 18px rgba(0,0,0,.18)}}
.su1{animation:su .28s ease both}
.su2{animation:su .28s .06s ease both}
.su3{animation:su .28s .11s ease both}
.su4{animation:su .28s .16s ease both}
.su5{animation:su .28s .22s ease both}

/* ── App shell ────────────────────────────────────────────────────────── */

/* Default: mobile-first narrow shell (tech / admin / auth) */
.app-shell{
  height:100%;
  min-height:0;
  max-width:480px;
  margin:0 auto;
  background:#0A0C12;
  border-inline:1px solid #222A38;
  display:flex;
  flex-direction:column;
  overflow:hidden
}
html[data-theme="light"] .app-shell{background:#F4F6FB;border-inline-color:#E4E8F0}

/* Dispatcher on wide screens — full viewport, no max-width cap */
@media (min-width:768px){
  .app-shell.app-shell--disp{
    max-width:100%;
    border-inline:none;
    margin:0
  }
}

/* 1.35.0 — Admin desktop shell растягивается на всю ширину окна без
   media-query: классом app-shell--admin-desktop помечаются ВСЕ админ-
   маршруты (см. AppShell.tsx). Внутри AdminPanel выбор лэйаута делает
   сам компонент через useAdminBreakpoint:
     • <768px → старый мобильный лэйаут (никаких полей с боков и так нет)
     • ≥768px → AdminDesktopShell с сайдбаром и контентом на всю ширину
   Что-то ниже 480px при mobile — нам не нужны искусственные поля. */
.app-shell.app-shell--admin-desktop{
  max-width:100%;
  border-inline:none;
  margin:0
}

/* ── Scroll containers ────────────────────────────────────────────────── */

/* Standard full-screen scroll (mobile all routes, tech/admin always) */
.screen-scroll{flex:1;min-height:0;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}

/* Dispatcher list column — same scroll behaviour, used inside fixed-width left pane */
.disp-list-scroll{
  flex:1;
  min-height:0;
  overflow-y:auto;
  overscroll-behavior:contain;
  -webkit-overflow-scrolling:touch
}

/* Dispatcher detail/panel right column */
.disp-panel-scroll{
  flex:1;
  min-height:0;
  overflow-y:auto;
  overscroll-behavior:contain;
  -webkit-overflow-scrolling:touch
}

/* ── Dashboard header in desktop mode ────────────────────────────────── */
/* Removes the bottom-bar that duplicates sidebar navigation on desktop  */
@media (min-width:1024px){
  .disp-bottom-bar{display:none !important}
  .disp-header-create{display:none !important}
}

/* 1.32.0 — В админке кнопка "Выйти" внизу видна только на десктопе.
   На мобиле (<768px) её роль выполняет AdminMobileMenu. */
@media (max-width:767px){
  .logout-bar-desktop-only{display:none !important}
}
`;

export function GlobalCSS() {
  return <style>{css}</style>;
}
